import gql from 'graphql-tag'

export const USER_QUERY = gql`
query me($date_Gte: Date, $date_Lte: Date) {
  me {
    id
    firstName
    lastName
    contact {
      firstName
      nutritionPlan{
        name
        calories
        pdf
      }
      myCoach {
        meetingUrl
        initialAssessmentLink
        recurringAssessmentLink
        profilePic
        user {
          firstName
          lastName
        }
      }
		}
  }
  actions(date_Lte: $date_Lte, date_Gte: $date_Gte) {
    edges {
      node {
        id
      }
    }
  }
  userProgram {
    incompleteAssessment {
      id
    }
    completedAssessment {
      id
    }
    activeProgram {
      id
      programStartDate
      nutritionPlan {
        pdf
      }
      program {
        name
      }
    }
  }
}
`

export const STAFF_QUERY = gql`
query staffUsers($isActive: Boolean, $isStaff: Boolean, $userProfile_UserType: String){
  users(isActive: $isActive, isStaff: $isStaff, userProfile_UserType: $userProfile_UserType) {
    edges {
      node {
        id
        firstName
        lastName
        email
        isStaff
        isActive
        userProfile {
          id
          profilePicture
          userType
          oneOnOneClientAllocation
          clubClientAllocation
          corporateClientAllocation
          oneOnOneClients
          clubClients
          corporateClubClients
        }
      }
    }
  }
}
`

